import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { User, Calendar, Heart } from 'lucide-react';
const requirements = [{
  icon: User,
  label: 'Tu nombre completo',
  note: 'Acceso al campo'
}, {
  icon: Calendar,
  label: 'Tu fecha de nacimiento',
  note: 'Acceso al campo'
}, {
  icon: Heart,
  label: 'Tu intención',
  note: 'Dirección del trabajo'
}];
export function DistanceWork() {
  return <section className="w-full bg-white py-32 px-6" data-id="element-48">
      <div className="max-w-4xl mx-auto" data-id="element-49">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif italic text-teal text-base md:text-lg text-center tracking-widest uppercase mb-6" style={{
        letterSpacing: '0.2em'
      }} data-id="element-50">
          Y aquí viene lo que más sorprende
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-serif text-teal-dark text-4xl md:text-5xl lg:text-6xl text-center leading-tight mb-16" data-id="element-51">
          No necesitás estar presente.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-6 text-lg md:text-xl text-gray-700 font-light leading-relaxed text-center max-w-2xl mx-auto mb-20" data-id="element-52">
          <p data-id="element-53">
            No hay sesión en vivo que coordinar.
            <br data-id="element-54" />
            No hay videollamada.
            <br data-id="element-55" />
            No hay que revivir nada.
          </p>
          <p className="font-serif italic text-teal-dark text-xl md:text-2xl pt-4" data-id="element-56">
            Solo necesito tres cosas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        staggerChildren: 0.15,
        delayChildren: 0.1
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-20" data-id="element-57">
          {requirements.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2 + index * 0.15
        }} className="bg-cream rounded-2xl p-8 border border-teal/10 flex flex-col items-center text-center" data-id="element-58">
              <div className="w-14 h-14 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-59">
                <item.icon className="text-teal" size={24} strokeWidth={1.5} data-id="element-60" />
              </div>
              <h3 className="font-serif text-teal-dark text-xl md:text-2xl mb-3" data-id="element-61">
                {item.label}
              </h3>
              <p className="text-gold-dark font-serif italic text-sm uppercase tracking-widest text-teal" data-id="element-62">
                {item.note}
              </p>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-6 text-lg text-gray-700 font-light leading-relaxed max-w-3xl mx-auto" data-id="element-63">
          <p data-id="element-64">
            La primera y la segunda me dan acceso a tu campo.
            <br data-id="element-65" />
            La tercera le da dirección al trabajo.
          </p>
          <p data-id="element-66">
            No necesitás tener todo claro para escribirme eso. No necesitás
            explicarme tu historia completa. Solo lo que sentís que está pesando
            — lo que te trajo hasta acá.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="my-16 flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 font-serif text-teal-dark text-xl md:text-2xl tracking-wide text-center" data-id="element-67">
          <span className="italic" data-id="element-68">Tu intención abre la puerta.</span>
          <span className="text-gold hidden md:inline" data-id="element-69">·</span>
          <span className="italic" data-id="element-70">El Método Llave trabaja.</span>
          <span className="text-gold hidden md:inline" data-id="element-71">·</span>
          <span className="italic" data-id="element-72">El campo revela.</span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-teal rounded-2xl p-10 md:p-12 text-white max-w-3xl mx-auto" data-id="element-73">
          <p className="font-light leading-relaxed text-lg md:text-xl mb-6" data-id="element-74">
            Y cuando termina, recibís un audio con la devolución completa. Lo
            que encontré. Lo que trabajé. Lo que se liberó. Lo que se restauró.
            Y lo que tu campo tiene para decirte sobre todo eso.
          </p>
          <p className="font-serif italic text-xl md:text-2xl text-gold leading-relaxed" data-id="element-75">
            Tuyo. Para escuchar cuando estés listo/a.
            <br data-id="element-76" />
            Para volver a él cuantas veces lo necesités.
          </p>
        </motion.div>
      </div>
    </section>;
}